import {useEffect,useRef,useState} from 'react';
import {api} from './lib/api';

export default function OwnerProfileLocationPanel(){
  const [ready,setReady]=useState<boolean|null>(null);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const alive=useRef(false);
  useEffect(()=>{
    alive.current=true;
    const controller=new AbortController();
    void api.request<{ready:boolean}>('/admin/profile-location',{signal:controller.signal}).then(value=>{
      if(!controller.signal.aborted)setReady(value.ready===true);
    }).catch(cause=>{if(!controller.signal.aborted)setError(cause instanceof Error?cause.message:'Verifica non riuscita.');});
    return()=>{alive.current=false;controller.abort();};
  },[]);
  async function activate(){
    if(busy||ready===true)return;
    setBusy(true);setError('');
    try{
      const value=await api.request<{ready:boolean}>('/admin/profile-location',{method:'POST',body:'{}'});
      if(value.ready!==true)throw new Error('Attivazione non confermata.');
      if(alive.current)setReady(true);
    }catch(cause){if(alive.current)setError(cause instanceof Error?cause.message:'Attivazione non riuscita.');}
    finally{if(alive.current)setBusy(false);}
  }
  return <section className="panel" style={{padding:22,marginBottom:22}} aria-label="Località dei profili pubblici">
    <h2>Località dei profili pubblici.</h2>
    <p>{ready===true?'Provincia o cantone e Paese sono disponibili nei profili. Non vengono pubblicati indirizzi di spedizione.':ready===false?'La nuova località pubblica richiede un aggiornamento del database. Il pulsante aggiunge solo il campo provincia/cantone, senza cancellare dati.':'Verifica della configurazione dei profili…'}</p>
    {ready!==true&&<button className="button button-outline" disabled={busy||ready===null} onClick={()=>void activate()}>{busy?'Attivazione…':'Attiva provincia e cantone'}</button>}
    {error&&<p className="form-error" role="alert">{error}</p>}
  </section>;
}
